import { Center } from "@chakra-ui/react"
import Logo from "../../components/Common/AppLogo"

const OrderPage = () => {
  return (
    <Center as="main" minH="100vh" p={8} bg="sidebar.900">
      <Logo />
    </Center>
  )
}

export default OrderPage
